import { Filter } from "./filter";
import { FilterGroup } from "./filterGroup";

export class MatchAll extends FilterGroup {
  constructor(override filters: Array<Filter>) {
    super("match.all", filters);
  }
}
